import { get } from 'lodash';

// TODO: Consider truncating these to recommended lengths and removing
// disallowed characters if any.
export function metaTitles(content) {
  return [
    { vmid: 'twitter:title', name: 'twitter:title', content },
    { vmid: 'og:title', property: 'og:title', content },
  ];
}

// TODO: Consider truncating these to recommended lengths and removing
// disallowed characters if any.
export function metaDescriptions(content) {
  return [
    { vmid: 'description', name: 'description', content },
    { vmid: 'twitter:description', name: 'twitter:description', content },
    { vmid: 'og:description', property: 'og:description', content },
  ];
}

export function metaFacebookImage(photo, imageAlt) {
  if (!photo) return [];

  const metaTags = [
    {
      vmid: 'og:image',
      property: 'og:image',
      content: photo.url,
    },
    {
      vmid: 'og:image:width',
      property: 'og:image:width',
      content: photo.metadata.width,
    },
    {
      vmid: 'og:image:height',
      property: 'og:image:height',
      content: photo.metadata.height,
    },
    {
      vmid: 'og:image:type',
      property: 'og:image:type',
      content: photo.metadata.mimeType,
    },
  ];

  if (imageAlt) {
    metaTags.push({
      vmid: 'og:image:alt',
      property: 'og:image:alt',
      content: imageAlt,
    });
  }

  return metaTags;
}

export function metaTwitterImage(photo, imageAlt) {
  if (!photo) return [];

  const metaTags = [
    {
      vmid: 'twitter:image',
      name: 'twitter:image',
      content: photo.url,
    },
  ];

  if (imageAlt) {
    metaTags.push({
      vmid: 'twitter:image:alt',
      name: 'twitter:image:alt',
      content: imageAlt,
    });
  }

  return metaTags;
}

export function metaTwitterCard(content) {
  return [
    {
      vmid: 'twitter:card',
      name: 'twitter:card',
      content,
    },
  ];
}

export function metaImages(photo, imageAlt) {
  return [
    ...metaFacebookImage(photo, imageAlt),
    ...metaTwitterImage(photo, imageAlt),
  ];
}

export function metaRobots(content = 'noindex') {
  return [
    {
      vmid: 'robots',
      name: 'robots',
      content,
    },
  ];
}

// Allows prerender to show the correct code to the Google crawler.
// See https://support.google.com/webmasters/answer/181708
// See https://prerender.io/documentation/best-practices
export function metaPrerenderStatusCode(status) {
  return {
    vmid: 'prerender-status-code',
    name: 'prerender-status-code',
    content: status,
  };
}

export function metaCanonicalLink() {
  if (!this.$route.name) {
    return [];
  }

  let path = this.$router.resolve({
    name: this.$route.name,
    params: { ...this.$route.params },
    query: { ...this.$route.query },
  }).href;

  if (path === '/') {
    path = '';
  } else {
    path += '/';
  }

  return [{ rel: 'canonical', href: `${window.location.origin}${path}` }];
}
